import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router';

import TeamCreate from './TeamCreate';
import TeamEdit from './TeamEdit';


const ModalTeamForm = () => {
  const [isOpenCreateForm, setIsOpenCreateForm] = useState(false);
  const [isOpenEditForm, setIsOpenEditForm] = useState(false);
  const { path } = useRouteMatch();

  useEffect(() => {
    if (path === '/dashboard/user/organizations/:id/team/new' || path === '/dashboard/admin/organizations/:id/team/new') {
      if (!isOpenCreateForm) {
        setIsOpenCreateForm(true);
      }
    } else if (path === '/dashboard/user/organizations/:id/team/:teamId' || path === '/dashboard/admin/organizations/:id/team/:teamId') {
      if (!isOpenEditForm) {
        setIsOpenEditForm(true);
      }
    } else {
      if (isOpenCreateForm) {
        setIsOpenCreateForm(false);
      }
      if (isOpenEditForm) {
        setIsOpenEditForm(false);
      }
    }
  }, [path, isOpenCreateForm, isOpenEditForm, setIsOpenCreateForm, setIsOpenEditForm]);


  if (isOpenCreateForm) {
    return <TeamCreate setIsOpenModal={setIsOpenCreateForm} />;
  }
  if (isOpenEditForm) {
    return <TeamEdit setIsOpenModal={setIsOpenEditForm} />;
  }

  return null;
};

export default ModalTeamForm;
